const emid2emitter = []
const emid2regs = []
const emid2subs = []

let regId = 0

export function nextRegId() {
  return ++regId
}

export function lastRegId() {
  return regId
}

export function register(reg, emitterList) {
  for (const emitter of emitterList) {
    let emid = emid2emitter.indexOf(emitter)
    if (emid === -1) {
      emid = emid2emitter.push(emitter) - 1
      const regs = emid2regs[emid] = [reg]
      const sub = emid2subs[emid] = _makeSub(regs)
      emitter.pre(sub)
    } else {
      const regs = emid2regs[emid]
      regs.push(reg)
    }
  }
}

function _makeSub(regs) {
  return function recalcOneventSub() {
    const local = regs.concat()
    for (const reg of local) {
      reg.brecalc()
    }
  }
}

export function release(reg, emitterList) {
  for (const emitter of emitterList) {
    const emid = emid2emitter.indexOf(emitter)
    const regs = emid2regs[emid]
    const regIndex = regs.indexOf(reg)
    regs.splice(regIndex, 1)

    if (regs.length === 0) {
      const sub = emid2subs[emid]
      emitter.off(sub)
      emid2emitter.splice(emid, 1)
      emid2subs.splice(emid, 1)
      emid2regs.splice(emid, 1)
    }
  }
}
